import React, { useEffect } from "react";
import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "iconsax-react";
import { getAdminBreadcrumbs } from "../../../navigation/adminNavigation";

export default function AdminNavigationBar() {
  const location = useLocation();
  const isAdminRoute = location.pathname === "/admin" || location.pathname.startsWith("/admin/");
  const breadcrumbs = getAdminBreadcrumbs(
    location.pathname,
    location.state?.navigationTitle,
    location.state?.navigationTrail,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (!isAdminRoute || location.pathname === "/admin" || location.pathname === "/admin/") return null;

  const parentPath = [...breadcrumbs].reverse().find((item) => item.path)?.path || "/admin";
  const isNestedPage = breadcrumbs.length > 2;

  return (
    <nav className="oekfb-admin-navigation" aria-label="Seitennavigation">
      {isNestedPage && (
        <Link className="oekfb-admin-navigation__back" to={parentPath}>
          <ArrowLeft size={15} />
          <span>Zurück</span>
        </Link>
      )}
      <Breadcrumb>
        {breadcrumbs.map((item, index) => (
          <Breadcrumb.Item key={`${item.title}-${index}`}>
            {item.path ? <Link to={item.path}>{item.title}</Link> : item.title}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </nav>
  );
}
